module.exports = __webpack_public_path__ + "img/farming-cow.6fd7d85f.png";